import DeployKeys from 'app/developer-v3/pages/partnerSettings/DeployKeys';
import Memberships from 'app/developer-v3/pages/partnerSettings/Memberships';
import PartnerSettings from 'app/developer-v3/pages/partnerSettings';
import Profile from 'app/developer-v3/pages/partnerSettings/Profile';

export default {
  component: PartnerSettings,
  routes: {
    '.': {
      onEnter({ router, routeTo }) {
        routeTo(`${router.next.url}/profile`);
      },
    },
    'deploy-keys': {
      isAuthRequired: true,
      component: DeployKeys,
    },
    email: {
      isAuthRequired: true,
      component: Memberships,
    },
    profile: {
      isAuthRequired: true,
      component: Profile,
    },
    'email/:secret': Memberships,
    'profile/:secret': Profile,
  },
};
